import { atom } from "nanostores"

export const $preApprovalHasUpdated = atom<boolean>(false)

export function setPreApprovalUpdated(newState: boolean) {
  $preApprovalHasUpdated.set(newState)
}
